import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/bebf4980-b572-4db0-a3ef-5702269e2842";
export const REGISTER_URL = "https://a.ntrk2.com/897a2364-95dc-4c61-9333-0e807bde114a";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bdbig.kzw2a.com/download?openExternalBrowser=1&id=gg4wieicusy09ac";

export * from "./codes";
export * from "./context";
